export default {
  blog: {
    seo: {
      title: 'Blog',
      description:
        'Artículos prácticos sobre última milla, gestión de flotas, experiencia del cliente y cómo los equipos usan Geofleet para operaciones más inteligentes.',
    },
    badge: 'Blog',
    hero: {
      title: 'Ideas para',
      titleHighlight: 'operaciones de entrega más inteligentes',
      description:
        'Artículos prácticos sobre última milla, gestión de flotas, experiencia del cliente y cómo los equipos usan Geofleet.',
    },
    filters: {
      categoryLabel: 'Categoría',
      allCategories: 'Todas las categorías',
      searchLabel: 'Buscar artículos por título',
      searchPlaceholder: 'Buscar artículos...',
      all: 'Todo',
    },
    featured: {
      label: 'Artículo destacado',
      readCta: 'Leer artículo',
    },
    list: {
      latestTitle: 'Últimos artículos',
      title: 'Artículos',
      showingInCategory: '{{count}} artículo en {{category}}',
      showingInCategory_other: '{{count}} artículos en {{category}}',
      defaultSubtitle: 'Nuevas perspectivas sobre entrega, despacho y operaciones de flota',
      article_one: '{{count}} artículo',
      article_other: '{{count}} artículos',
    },
    empty: {
      title: 'Ningún artículo coincide con tu búsqueda',
      hint: 'Prueba otras palabras clave o elige otra categoría.',
    },
    card: {
      readMore: 'Leer más',
    },
    pagination: {
      previous: 'Anterior',
      next: 'Siguiente',
      pageOf: 'Página {{current}} de {{total}}',
    },
    cta: {
      title: '¿Listo para mejorar tus operaciones de entrega?',
      subtitle: 'Empieza en minutos. Planes desde 100 $ al mes para 10 conductores.',
    },
    post: {
      ogImageAlt: '{{title}} — Blog de Geofleet',
      backToBlog: 'Volver al blog',
      updatedOn: 'Actualizado el {{date}}',
      publishedOn: 'Publicado el {{date}}',
      disclosure: 'Aviso: esta comparativa la publica Geofleet y situamos nuestro producto en primer lugar. Cada uno de los demás productos se describe a partir de las páginas públicas de producto y precios de su proveedor, con un «ideal para» justo.',
      pitch: {
        eyebrow: 'Prueba nuestra opción n.º 1',
        title: 'Geofleet: desde 100 $ al mes para 10 conductores',
        text: 'Empieza con Geofleet Lite por 100 $ al mes para 10 conductores y 2.000 pedidos, con planificación de rutas, seguimiento en vivo, enlaces de seguimiento para clientes, prueba de entrega y pago contra entrega para un hub. Los equipos con varios hubs pasan a Professional desde 19 $ por conductor al mes, con seguimiento con tu marca y agentes de IA en planes superiores.',
        startFree: 'Empezar',
        bookDemo: 'Reservar una demo',
        caseStudy: 'Leer el caso de éxito',
      },
      keyTakeaways: 'Puntos clave',
      tocAriaLabel: 'Tabla de contenidos',
      tocTitle: 'Contenido',
      relatedTitle: 'Artículos relacionados',
      cta: {
        title: 'Explora el centro de mando de Geofleet',
        subtitle: 'Descubre cómo los agentes de IA pueden optimizar tus operaciones. Empieza ya o reserva una demo con nuestro equipo.',
        bookDemo: 'Reservar una demo de Geofleet',
        aiAgentsLink: 'Agentes de IA en Geofleet',
      },
    },
  },
};
